import { NgModule } from '@angular/core';
import { AuthConfig, I18nConfig, OccConfig, provideConfig, } from "@spartacus/core";
import { defaultB2bOccConfig } from "@spartacus/setup";
import { defaultCmsContentProviders, layoutConfig, mediaConfig } from "@spartacus/storefront";
import { environment } from 'src/environments/environment';
import { ProductUpdatedEvent } from '../generac/events/product.event';
import { genCmsConfig } from '../generac/configs/cms.config';
import { providersConfig } from '../generac/configs/providers.config';
import { genEndpointsConfig } from '../generac/configs/endpoints.config';
import { genLayoutConfig } from '../generac/configs/layout.config';
import { genRoutingConfig } from '../generac/configs/routing.config';
import { genCheckoutConfig } from '../generac/configs/checkout.config';
import { genGlobalMessageConfig } from '../generac/configs/global-message.config';
import { genIconsConfig } from '../generac/configs/icons.config';
import { translationsEn, translationChunksConfig } from '@spartacus/assets';

@NgModule({
  declarations: [],
  providers: [
    provideConfig(layoutConfig),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    provideConfig(<OccConfig>{
      backend: {
        ...environment.backend,
        loadingScopes: {
          product: {
            details: {
              reloadOn: [ProductUpdatedEvent]
            }
          }
        }
      },
    }),
    provideConfig(<OccConfig>genEndpointsConfig),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: translationsEn },
        chunks: translationChunksConfig,
        fallbackLang: 'en'
      },
    }),
    provideConfig(genLayoutConfig),
    provideConfig(defaultB2bOccConfig),
    provideConfig(genRoutingConfig),
    provideConfig(genCheckoutConfig),
    provideConfig(genGlobalMessageConfig),
    provideConfig(genCmsConfig),
    provideConfig(genIconsConfig),
    provideConfig(<AuthConfig>{
      authentication: {
        customLoginPage: undefined,
        OAuthLibConfig: {
          responseType: '',
        },
      },
    }),
    ...providersConfig,
  ]
})
export class SpartacusConfigurationModule { }
